import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/images/selectArrow.gif'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  class: "pageTitleTab left",
  style: {"margin-bottom":"20px"}
}
const _hoisted_3 = {
  class: "left",
  style: {"position":"relative"}
}
const _hoisted_4 = { class: "hangulAlign" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "textArea left" }
const _hoisted_7 = { class: "tableTitleText" }
const _hoisted_8 = { class: "searchArea right" }
const _hoisted_9 = {
  class: "contDetailViewSelectOutputText",
  style: {}
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "textCenter" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "textCenter" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "textCenter" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "textCenter" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "textCenter" }
const _hoisted_21 = { class: "textCenter" }
const _hoisted_22 = { class: "textCenter" }
const _hoisted_23 = { class: "box" }
const _hoisted_24 = { class: "tableList" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "poRel" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onUpdate:modelValue", "onChange"]
const _hoisted_39 = ["onUpdate:modelValue", "onChange"]
const _hoisted_40 = { class: "poRel" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "poRel" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = ["value"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "conBottom" }
const _hoisted_48 = { class: "rightbtn" }
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "conBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JSDPageCtrl = _resolveComponent("JSDPageCtrl")!
  const _component_JSDCustView = _resolveComponent("JSDCustView")!
  const _component_CustSelectFilter = _resolveComponent("CustSelectFilter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[82] || (_cache[82] = _createStaticVNode("<div class=\"layer deletAlt\" style=\"display:none;z-index:2000;\"><div class=\"layerTitle\">알림</div><div class=\"layerMain\"><div class=\"layerMainText\"><span class=\"bold\">수정하신 내용을 저장하지 않으셨습니다.</span><br><br> 저장하시겠습니까? </div></div><div class=\"layerBtnArea\"><button class=\"blueBtn\">저장</button>  <button class=\"grayBtn\">취소</button></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '0' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => {$options.select_assign('BLVR_CATE', '0');})
        }, "전체", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '1' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => {$options.select_assign('BLVR_CATE', '1');})
        }, "상생방송", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '4' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => {$options.select_assign('BLVR_CATE', '4');})
        }, "역사광복", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tabBtn", {select : $data.api.list.BLVR_CATE == '9' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => {$options.select_assign('BLVR_CATE', '9');})
        }, "미지정", 2)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "selectListBox jsdPosition2",
          onClick: _cache[4] || (_cache[4] = ($event: any) => {$options.select_layerView();})
        }, [...(_cache[50] || (_cache[50] = [
          _createTextVNode(" 상세조건 ", -1),
          _createElementVNode("div", { class: "selectArrowimg right" }, [
            _createElementVNode("img", { src: _imports_0 })
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.han_key_list, (r) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass({ select: $data.api.list.HAN_KEY === r.value}),
              onClick: ($event: any) => {$options.select_assign('ㄱㄴㄷ', r);}
            }, [
              _createElementVNode("span", null, _toDisplayString(r.title), 1)
            ], 10, _hoisted_5))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.ui.is_order) = $event)),
            onChange: _cache[6] || (_cache[6] = ($event: any) => {$options.select_assign('order', '');})
          }, null, 544), [
            [_vModelCheckbox, $data.ui.is_order]
          ]),
          _cache[51] || (_cache[51] = _createTextVNode("등록순 정렬", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "search",
          maxlength: "18",
          placeholder: "이름 휴대폰 번호 검색",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.api.list.SEARCH_KEY) = $event)),
          onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => {$options.movePage(1);}, ["enter"]))
        }, null, 544), [
          [_vModelText, $data.api.list.SEARCH_KEY]
        ]),
        _createElementVNode("div", {
          class: "searchBtn",
          onClick: _cache[9] || (_cache[9] = ($event: any) => {$options.movePage(1);})
        }, "검색")
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "gmFont bold" }, "선택된 상세조건", -1)),
        _createTextVNode(" : " + _toDisplayString($data.ui.filter_val.SELECT_TXT), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("ul", {
        class: "selectListBoxLayer left",
        style: _normalizeStyle({ top: $data.ui.group_layer.top + 'px', left: $data.ui.group_layer.left+ 'px'})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.group_list, (r) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.ui.group_layer.group_nos) = $event)),
                value: r.GROUP_NO
              }, null, 8, _hoisted_10), [
                [_vModelCheckbox, $data.ui.group_layer.group_nos]
              ]),
              _createTextVNode(_toDisplayString(r.GROUP_NM), 1)
            ])
          ]))
        }), 256)),
        (!$data.arr.group_list.length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [...(_cache[53] || (_cache[53] = [
              _createElementVNode("label", null, "등록된 그룹이 없습니다.", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("button", {
            class: "grayBtn mgR10",
            onClick: _cache[11] || (_cache[11] = ($event: any) => {$options.groupView($event, '', false);})
          }, "취소"),
          ($data.arr.group_list.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "blueBtn",
                onClick: _cache[12] || (_cache[12] = ($event: any) => {$options.cust_assign('GROUP',$data.ui.group_layer.mode , '', '');})
              }, "저장"))
            : _createCommentVNode("", true)
        ])
      ], 4), [
        [_vShow, $data.ui.group_layer.is_view]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("ul", {
        class: "selectListBoxLayer left",
        style: _normalizeStyle({ top: $data.ui.blar_cate_cd_layer.top + 'px', left: $data.ui.blar_cate_cd_layer.left+ 'px'})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.blar_cate_cd_list, (r) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "subject",
                value: r.CODE,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.ui.blar_cate_cd_layer.blar_cate_cd) = $event))
              }, null, 8, _hoisted_13), [
                [_vModelRadio, $data.ui.blar_cate_cd_layer.blar_cate_cd]
              ]),
              _createTextVNode(_toDisplayString(r.CODE_NM), 1)
            ])
          ]))
        }), 256)),
        _createElementVNode("li", _hoisted_14, [
          _createElementVNode("button", {
            class: "grayBtn mgR10",
            onClick: _cache[14] || (_cache[14] = ($event: any) => {$options.blar_cateView($event, '', false);})
          }, "취소"),
          _createElementVNode("button", {
            class: "blueBtn",
            onClick: _cache[15] || (_cache[15] = ($event: any) => {$options.cust_assign('BLVR_CATE_CD','all', '', '');})
          }, "저장")
        ])
      ], 4), [
        [_vShow, $data.ui.blar_cate_cd_layer.is_view]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("ul", {
        class: "selectListBoxLayer left",
        style: _normalizeStyle({ top: $data.ui.blar_rela_cd_layer.top + 'px', left: $data.ui.blar_rela_cd_layer.left+ 'px'})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.blar_rela_cd_list, (r) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "type",
                value: r.CODE,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($data.ui.blar_rela_cd_layer.blar_rela_cd) = $event))
              }, null, 8, _hoisted_15), [
                [_vModelRadio, $data.ui.blar_rela_cd_layer.blar_rela_cd]
              ]),
              _createTextVNode(_toDisplayString(r.CODE_NM), 1)
            ])
          ]))
        }), 256)),
        _createElementVNode("li", _hoisted_16, [
          _createElementVNode("button", {
            class: "grayBtn mgR10",
            onClick: _cache[17] || (_cache[17] = ($event: any) => {$options.blar_relaView($event, '', false);})
          }, "취소"),
          _createElementVNode("button", {
            class: "blueBtn",
            onClick: _cache[18] || (_cache[18] = ($event: any) => {$options.cust_assign('BLVR_RELA_CD','all', '', '');})
          }, "저장")
        ])
      ], 4), [
        [_vShow, $data.ui.blar_rela_cd_layer.is_view]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("ul", {
        class: "selectListBoxLayer left",
        style: _normalizeStyle({ top: $data.ui.regi_cd_layer.top + 'px', left: $data.ui.regi_cd_layer.left+ 'px'})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.regi_cd_list, (r) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: r.CODE,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($data.ui.regi_cd_layer.regi_cd) = $event))
              }, null, 8, _hoisted_17), [
                [_vModelRadio, $data.ui.regi_cd_layer.regi_cd]
              ]),
              _createTextVNode(_toDisplayString(r.CODE_NM), 1)
            ])
          ]))
        }), 256)),
        _createElementVNode("li", _hoisted_18, [
          _createElementVNode("button", {
            class: "grayBtn mgR10",
            onClick: _cache[20] || (_cache[20] = ($event: any) => {$options.regi_View($event, '', false);})
          }, "취소"),
          _createElementVNode("button", {
            class: "blueBtn",
            onClick: _cache[21] || (_cache[21] = ($event: any) => {$options.cust_assign('REGI_CD','all', '', '');})
          }, "저장")
        ])
      ], 4), [
        [_vShow, $data.ui.regi_cd_layer.is_view]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("ul", {
        class: "selectListBoxLayer left",
        style: _normalizeStyle({ top: $data.ui.jsdbook_layer.top + 'px', left: $data.ui.jsdbook_layer.left+ 'px'})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.book_list, (r) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($data.ui.jsdbook_layer.book_nos) = $event)),
                value: r.BOOK_NO
              }, null, 8, _hoisted_19), [
                [_vModelCheckbox, $data.ui.jsdbook_layer.book_nos]
              ]),
              _createTextVNode(_toDisplayString(r.TITLE), 1)
            ])
          ]))
        }), 256)),
        _createElementVNode("li", _hoisted_20, [
          _createElementVNode("button", {
            class: "grayBtn mgR10",
            onClick: _cache[23] || (_cache[23] = ($event: any) => {$options.book_View($event, '', false);})
          }, "취소"),
          _createElementVNode("button", {
            class: "blueBtn",
            onClick: _cache[24] || (_cache[24] = ($event: any) => {$options.cust_assign('BOOK',$data.ui.jsdbook_layer.mode , '', '');})
          }, "저장")
        ])
      ], 4), [
        [_vShow, $data.ui.jsdbook_layer.is_view]
      ])
    ]),
    _withDirectives(_createElementVNode("ul", {
      class: "selectListBoxLayer left",
      style: _normalizeStyle({ top: $data.ui.voca_layer.top + 'px', left: $data.ui.voca_layer.left+ 'px'})
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "thInputText left mgB10",
        placeholder: "호칭 입력",
        style: {"width":"150px","padding":"5px","border-bottom":"1px solid #000000"},
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($data.ui.voca_layer.voca_nm) = $event)),
        maxlength: "50"
      }, null, 512), [
        [_vModelText, $data.ui.voca_layer.voca_nm]
      ]),
      _createElementVNode("li", _hoisted_21, [
        _createElementVNode("button", {
          class: "grayBtn mgR10",
          onClick: _cache[26] || (_cache[26] = ($event: any) => {$options.voca_View($event, '', false);})
        }, "취소"),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[27] || (_cache[27] = ($event: any) => {$options.cust_assign('voca', 'all');})
        }, "저장")
      ])
    ], 4), [
      [_vShow, $data.ui.voca_layer.is_view]
    ]),
    _createElementVNode("ul", {
      class: "selectListBoxLayer left",
      style: _normalizeStyle({ top: $data.ui.age_layer.top + 'px', left: $data.ui.age_layer.left+ 'px', display : $data.ui.age_layer.is_view === true ? 'block' : 'none'})
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "thInputText",
        style: {"width":"45px","padding":"5px","border-bottom":"1px solid #000000"},
        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($data.ui.age_layer.age) = $event)),
        onChange: _cache[29] || (_cache[29] = ($event: any) => {$options.age_assign('AGE', 'all', _ctx.r);})
      }, null, 544), [
        [_vModelText, $data.ui.age_layer.age]
      ]),
      _cache[54] || (_cache[54] = _createTextVNode("세 ", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "thInputText",
        style: {"width":"65px","padding":"5px","border-bottom":"1px solid #000000"},
        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($data.ui.age_layer.year) = $event)),
        onChange: _cache[31] || (_cache[31] = ($event: any) => {$options.age_assign('YE', 'all', _ctx.r);})
      }, null, 544), [
        [_vModelText, $data.ui.age_layer.year]
      ]),
      _cache[55] || (_cache[55] = _createTextVNode("년 ", -1)),
      _createElementVNode("li", _hoisted_22, [
        _createElementVNode("button", {
          class: "grayBtn mgR10",
          onClick: _cache[32] || (_cache[32] = ($event: any) => {$options.age_View($event, '', false);})
        }, "취소"),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[33] || (_cache[33] = ($event: any) => {$options.cust_assign('age', 'all');})
        }, "저장")
      ])
    ], 4),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("table", _hoisted_24, [
        _createElementVNode("tr", null, [
          _cache[74] || (_cache[74] = _createElementVNode("th", null, "번호", -1)),
          _cache[75] || (_cache[75] = _createElementVNode("th", null, "이름", -1)),
          _createElementVNode("th", null, [
            _cache[56] || (_cache[56] = _createTextVNode(" 호칭", -1)),
            _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[34] || (_cache[34] = ($event: any) => {$options.voca_View($event, 'all', true);})
            }, "일괄설정")
          ]),
          _cache[76] || (_cache[76] = _createElementVNode("th", null, [
            _createTextVNode("대표"),
            _createElementVNode("br"),
            _createTextVNode("연락처")
          ], -1)),
          _createElementVNode("th", null, [
            _cache[58] || (_cache[58] = _createTextVNode(" 그룹", -1)),
            _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[35] || (_cache[35] = ($event: any) => {$options.groupView($event, 'all', true);})
            }, "일괄설정")
          ]),
          _createElementVNode("th", null, [
            _cache[60] || (_cache[60] = _createTextVNode(" 대상자", -1)),
            _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[36] || (_cache[36] = ($event: any) => {$options.blar_cateView($event, 'all', true);})
            }, "일괄설정")
          ]),
          _createElementVNode("th", null, [
            _cache[62] || (_cache[62] = _createTextVNode(" 등급", -1)),
            _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[37] || (_cache[37] = ($event: any) => {$options.cust_assign('RTNG_CD', 'all', '', 'A');})
            }, "A"),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[38] || (_cache[38] = ($event: any) => {$options.cust_assign('RTNG_CD', 'all', '', 'B');})
            }, "B"),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[39] || (_cache[39] = ($event: any) => {$options.cust_assign('RTNG_CD', 'all', '', 'C');})
            }, "C"),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[40] || (_cache[40] = ($event: any) => {$options.cust_assign('RTNG_CD', 'all', '', 'D');})
            }, "D")
          ]),
          _createElementVNode("th", null, [
            _cache[64] || (_cache[64] = _createTextVNode(" 성별", -1)),
            _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[41] || (_cache[41] = ($event: any) => {$options.cust_assign('IS_SEX', 'all', '', 1);})
            }, "남"),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[42] || (_cache[42] = ($event: any) => {$options.cust_assign('IS_SEX', 'all', '', 0);})
            }, "여")
          ]),
          _createElementVNode("th", null, [
            _cache[66] || (_cache[66] = _createTextVNode(" 나이", -1)),
            _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[43] || (_cache[43] = ($event: any) => {$options.age_View($event, 'all', true);})
            }, "일괄설정")
          ]),
          _createElementVNode("th", null, [
            _cache[68] || (_cache[68] = _createTextVNode(" 유형", -1)),
            _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[44] || (_cache[44] = ($event: any) => {$options.blar_relaView($event, 'all', true);})
            }, "일괄설정")
          ]),
          _createElementVNode("th", null, [
            _cache[70] || (_cache[70] = _createTextVNode(" 지역", -1)),
            _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[45] || (_cache[45] = ($event: any) => {$options.regi_View($event, 'all', true);})
            }, "일괄설정")
          ]),
          _createElementVNode("th", null, [
            _cache[72] || (_cache[72] = _createTextVNode(" 도서", -1)),
            _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "whiteBtn mgT05",
              onClick: _cache[46] || (_cache[46] = ($event: any) => {$options.book_View($event, 'all', true);})
            }, "일괄설정")
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.cust_list, (r) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _createElementVNode("td", null, _toDisplayString(r.ROW_NO), 1),
            _createElementVNode("td", {
              onClick: ($event: any) => {$options.cust_layer_view(r);},
              style: {"cursor":"pointer"}
            }, _toDisplayString(r.CUST_NM) + "(" + _toDisplayString(r.CUST_AGE) + ")", 9, _hoisted_25),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "thInputText",
                style: {"width":"60px"},
                "onUpdate:modelValue": ($event: any) => ((r.VOCA_NM) = $event),
                maxlength: "50"
              }, null, 8, _hoisted_26), [
                [_vModelText, r.VOCA_NM]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "thInputText",
                style: {"width":"120px"},
                "onUpdate:modelValue": ($event: any) => ((r.PHONE_CNO) = $event)
              }, null, 8, _hoisted_27), [
                [_vModelText, r.PHONE_CNO]
              ])
            ]),
            _createElementVNode("td", {
              class: "poRel",
              onClick: ($event: any) => {$options.groupView($event, 'one', true, r);}
            }, [
              _createElementVNode("button", null, _toDisplayString(r.GROUP_NMS.length === 0 ? '그룹선택' : r.GROUP_NMS), 1)
            ], 8, _hoisted_28),
            _createElementVNode("td", _hoisted_29, [
              _withDirectives(_createElementVNode("select", {
                class: "selectBox right",
                "onUpdate:modelValue": ($event: any) => ((r.BLVR_CATE_CD) = $event)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.blar_cate_cd_list, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: c.CODE
                  }, _toDisplayString(c.CODE_NM), 9, _hoisted_31))
                }), 256))
              ], 8, _hoisted_30), [
                [_vModelSelect, r.BLVR_CATE_CD]
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["mgT05", [r.RTNG_CD === 'A' ? 'blueBtn' : 'whiteBtn']]),
                onClick: ($event: any) => {$options.cust_assign('RTNG_CD', 'one', r.CUST_NO, 'A');}
              }, "A", 10, _hoisted_32),
              _createElementVNode("button", {
                class: _normalizeClass(["mgT05", [r.RTNG_CD === 'B' ? 'blueBtn' : 'whiteBtn']]),
                onClick: ($event: any) => {$options.cust_assign('RTNG_CD', 'one', r.CUST_NO, 'B');}
              }, "B", 10, _hoisted_33),
              _createElementVNode("button", {
                class: _normalizeClass(["mgT05", [r.RTNG_CD === 'C' ? 'blueBtn' : 'whiteBtn']]),
                onClick: ($event: any) => {$options.cust_assign('RTNG_CD', 'one', r.CUST_NO, 'C');}
              }, "C", 10, _hoisted_34),
              _createElementVNode("button", {
                class: _normalizeClass(["mgT05", [r.RTNG_CD === 'D' ? 'blueBtn' : 'whiteBtn']]),
                onClick: ($event: any) => {$options.cust_assign('RTNG_CD', 'one', r.CUST_NO, 'D');}
              }, "D", 10, _hoisted_35)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: _normalizeClass(["mgT05", [r.IS_SEX === 1 ? 'blueBtn' : 'whiteBtn']]),
                onClick: ($event: any) => {$options.cust_assign('IS_SEX', 'one', r.CUST_NO, 1);}
              }, "남", 10, _hoisted_36),
              _createElementVNode("button", {
                class: _normalizeClass(["mgT05", [r.IS_SEX === 0 ? 'blueBtn' : 'whiteBtn']]),
                onClick: ($event: any) => {$options.cust_assign('IS_SEX', 'one', r.CUST_NO, 0);}
              }, "여", 10, _hoisted_37)
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "thInputText",
                style: {"width":"35px"},
                "onUpdate:modelValue": ($event: any) => ((r.CUST_AGE) = $event),
                onChange: ($event: any) => {$options.age_assign('AGE', 'one', r);}
              }, null, 40, _hoisted_38), [
                [_vModelText, r.CUST_AGE]
              ]),
              _cache[77] || (_cache[77] = _createTextVNode("세 ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "thInputText",
                style: {"width":"45px"},
                "onUpdate:modelValue": ($event: any) => ((r.BIRT_YE) = $event),
                onChange: ($event: any) => {$options.age_assign('YE', 'one', r);}
              }, null, 40, _hoisted_39), [
                [_vModelText, r.BIRT_YE]
              ]),
              _cache[78] || (_cache[78] = _createTextVNode("년 ", -1))
            ]),
            _createElementVNode("td", _hoisted_40, [
              _withDirectives(_createElementVNode("select", {
                class: "selectBox right",
                "onUpdate:modelValue": ($event: any) => ((r.BLVR_RELA_CD) = $event)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.blar_rela_cd_list, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: c.CODE
                  }, _toDisplayString(c.CODE_NM), 9, _hoisted_42))
                }), 256))
              ], 8, _hoisted_41), [
                [_vModelSelect, r.BLVR_RELA_CD]
              ])
            ]),
            _createElementVNode("td", _hoisted_43, [
              _withDirectives(_createElementVNode("select", {
                class: "selectBox right",
                "onUpdate:modelValue": ($event: any) => ((r.REGI_CD) = $event)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.regi_cd_list, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: c.CODE
                  }, _toDisplayString(c.CODE_NM), 9, _hoisted_45))
                }), 256))
              ], 8, _hoisted_44), [
                [_vModelSelect, r.REGI_CD]
              ])
            ]),
            _createElementVNode("td", {
              class: "poRel",
              onClick: ($event: any) => {$options.book_View($event, 'one', true, r);}
            }, [
              _createElementVNode("button", null, _toDisplayString(r.BOOK_NMS.length === 0 ? '도서선택' : r.BOOK_NMS), 1)
            ], 8, _hoisted_46)
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_JSDPageCtrl, {
          ref: "pageCtrl",
          page: $data.page,
          cntPage: $data.api.list.CNT_PAGE,
          maxCnt: $data.page.maxCnt,
          onPageMove: $options.movePage
        }, null, 8, ["page", "cntPage", "maxCnt", "onPageMove"]),
        _createElementVNode("div", _hoisted_48, [
          _withDirectives(_createElementVNode("select", {
            class: "selectBox left",
            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (($data.api.list.CNT_PAGE) = $event)),
            onChange: _cache[48] || (_cache[48] = ($event: any) => ($options.movePage(1)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.api.page_cnt, (n) => {
              return (_openBlock(), _createElementBlock("option", { value: n }, _toDisplayString(`${n}줄 보기`), 9, _hoisted_49))
            }), 256))
          ], 544), [
            [_vModelSelect, $data.api.list.CNT_PAGE]
          ])
        ])
      ]),
      _cache[81] || (_cache[81] = _createElementVNode("div", null, [
        _createTextVNode(" ※ 수정하신 내용은 "),
        _createElementVNode("span", { class: "red" }, "현재 보고 있는 페이지만 저장"),
        _createTextVNode("되므로, 저장 후 다음 페이지로 이동하여 수정을 계속하여 주십시오. ")
      ], -1)),
      _createElementVNode("div", _hoisted_50, [
        _cache[79] || (_cache[79] = _createElementVNode("button", { class: "grayBtn" }, " 취소 ", -1)),
        _cache[80] || (_cache[80] = _createTextVNode("  ", -1)),
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[49] || (_cache[49] = ($event: any) => {$options.bulk_save();})
        }, " 저장 ")
      ]),
      _createVNode(_component_JSDCustView, {
        ref: "JSDCustView",
        cust_no: $data.ui.cust_layer.cust_no
      }, null, 8, ["cust_no"])
    ]),
    _createVNode(_component_CustSelectFilter, {
      ref: "CustSelectFilter",
      top: 161,
      left: 661,
      init_filter: $data.ui.filter_val,
      onSetCustSelectFilter: $options.setCustSelectFilter
    }, null, 8, ["init_filter", "onSetCustSelectFilter"])
  ], 64))
}